const _excluded = ["fill"],
  _excluded2 = ["children", "size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import styled, { css } from "styled-components";
import { pickFgColor, validFgColorValues } from "@nib/layout"; /* Sizing scale */
const sizes = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 48,
  xl: 64,
  xxl: 96,
  xxxl: 128
};
const isNamedColor = color => {
  if (!color) return false;
  if (validFgColorValues.includes(color)) {
    return true;
  }
  return false;
};
const setColor = props => {
  if (isNamedColor(props.fill)) {
    return css`
      color: ${pickFgColor(props.fill)};
    `;
  }
  return css`
    color: ${props.fill};
  `;
};
const Svg = styled(_ref => {
  let {
      fill
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", rest);
})`
  display: inline-block;
  ${props => setColor(props)};
`;
const getSize = size => {
  return sizes[size] || (isNaN(size) ? null : size);
};
const BaseIcon = _ref2 => {
  let {
      children,
      size
    } = _ref2,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Svg, _extends({
    role: "img",
    viewBox: "0 0 24 24",
    height: getSize(size),
    width: getSize(size),
    "aria-hidden": true
  }, otherProps), children);
};
BaseIcon.displayName = "BaseIcon";
export default BaseIcon;